import type { Subscription } from '../../types';
import { isExpiredTrialWithNoPlan as isLegacyExpiredTrialWithNoPlan } from '../legacySubscription/isExpiredTrialWithNoPlan';
import { isExpiredTrialWithNoPlan as isModernExpiredTrialWithNoPlan } from '../modernSubscription/isExpiredTrialWithNoPlan';

import { isModernSubscription } from './isModernSubscription';

export function isExpiredTrialWithNoPlan(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernExpiredTrialWithNoPlan(subscription);
  }

  return isLegacyExpiredTrialWithNoPlan(subscription);
}
